export default __webpack_public_path__ + "static/media/pp-bg-m.8c7e362d.svg";